import {Component, inject, input} from '@angular/core';
import {DataService} from "../services/data.service";
import {AccessService} from "../services/access.service";
import Swal from "sweetalert2";

@Component({
    selector: 'app-jitsi',
    template: `
        <i class="fa-solid fa-video text-success ms-2" (click)="openJitsi($event)"></i>
    `
})
export class JitsiComponent {

    id_franchisee = input.required<number>();
    phone = input.required<string>();
    contact = input.required<string>();

    private dataService = inject(DataService);
    private accessService = inject(AccessService);

    openJitsi(event: any) {
        event.stopPropagation();

        const requester = this.accessService.user.firstname + ' ' + this.accessService.user.lastname;

        Swal.fire({
            title: 'Sicher?',
            text: 'Es wird ein Videocall mit dem Franchisenehmer gestartet.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Jitsi/open', {
                    id_franchisee: this.id_franchisee(),
                    phone: this.phone(),
                    contact: this.contact(),
                    requester: requester
                }).subscribe(response => {
                    // open a new tab with the jitsi meeting url
                    window.open(response.url + '#userInfo.displayName="' + requester + '"', '_blank');
                })
            }
        });

    }
}
